/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */
import React, { useContext, useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { ThemeContext } from '../../contexts/ThemeContext';
import ErrorBoundary from '../general/ErrorBoundary';
import GeneralNavbar from '../general/GeneralNavbar';
import {PsychometricContext} from '../../contexts/PsychometricContext';
import PsychometricTestNavbar from '../psychometric/PyschometricTestNavbar';
import PsychometricService from '../../services/PsychometricService';

const PsychometricTestConclusion = ({  
    goToNextStep, 
    goToPreviousStep, 
    history, 
    location,
    isOrganization,
    signedID,
    signedFirstName,
    signedLastName,
    signedOrganization,
    signedEmail,
    ...props  }) => {
    const { theme, fontFamily, colors, fontWeight } = useContext(ThemeContext);
    const [isLoading, setIsLoading] = useState(false);
    const { isStudent } = useContext(PsychometricContext);
    const isIframe = new URLSearchParams(location.search).get('iframe') === 'true';

    useEffect(() => {
        window.scrollTo(0, 0);
        const markComplete = async () => {
            try {
                await PsychometricService.markTestComplete(
                    signedID,
                    signedFirstName,
                    signedLastName,
                    signedOrganization,
                    signedEmail
                );
                console.log('Test marked as complete');
            } catch (error) {
                console.log("Full error object:", error);
                console.error('Error marking test as complete:', error);
            }
        };
        
        markComplete();

        if (!isIframe) {
            const timeoutId = setTimeout(() => {
                handleFinish();
            }, 5000);
            return () => clearTimeout(timeoutId);
        }
    }, []);

    const handleFinish = () => {
        setIsLoading(true);
        sessionStorage.removeItem('psychometricTestStep');
        history.push('/'); 
    };

    return (
        <div style={{ fontFamily: fontFamily.primary }}>
            {isIframe && (
                <ErrorBoundary errorAt="At PsychometricTestConclusion PsychometricTestNavbar">
                    <PsychometricTestNavbar signedOrganization={signedOrganization} />
                </ErrorBoundary>
            )}
            {!isIframe && (
                <ErrorBoundary errorAt="At General PsychometricTestConclusion GeneralNavbar">
              <PsychometricTestNavbar signedOrganization={signedOrganization} />
                </ErrorBoundary>
            )}

            <div className="row p-3 px-5">
                <h1 className="col-md-12 col-12 mb-3" style={{ fontWeight: fontWeight.bold, fontSize: "1.5rem", color: colors.primaryGreenDark }}>
                    DECODING TALENT LANDSCAPE AND PERSONALITY MAPPING
                </h1>
                <h2 className="col-md-12 col-12 mb-3" style={{ fontWeight: fontWeight.bold, fontSize: "1rem", color: colors.primaryGreenDark }}>
                     {isStudent ? "Building a strong academic culture for success" : "Building a strong workplace culture for success"}
                </h2>

                <div className="col-md-12 col-12 mb-4">
                    <h2 style={{ fontWeight: fontWeight.bold, fontSize: "1rem" }}>THANK YOU</h2>
                    <p style={{ fontSize: "0.8rem" }}>
                        {isOrganization ? (
                            "Thank you for taking the Psychometric test. Your results will be compiled into a report sent to the organization you belong to."
                        ) : (
                            "Thank you for taking the Psychometric test. Your results will be compiled into a report and sent to your email address. You may also access your results by logging in to your account."
                        )}
                    </p>
                    {!isIframe && (
                        <p style={{ fontSize: "0.8rem" }}>
                            You will be redirected to the home page in a few seconds.
                        </p>
                    )}
                </div>

                <div className="col-md-12 col-12 mb-4 d-flex justify-content-between">
                    {isIframe ? (
                        <p style={{ fontSize: "0.8rem" }}>You may close this window</p>
                    ) : null}
                </div>
            </div>
            <footer style={theme.psychometricTestFooter}>
                Powered by Umang Wellness
            </footer>
        </div>
    );
}

export default PsychometricTestConclusion;
